import DBModal from "../DBModal";
import iranIcon from "./../../../asset/icons/iran-flag.svg";
import englandIcon from "./../../../asset/icons/england-flag.svg";
import "./style.scss";
import { useTranslation } from "react-i18next";
import DBButton from "./../DBButton/index";
import { useEffect } from "react";
export default function InstallAppModal({ show, onHide, onReject }) {
    const onRejectHandle = () => {
        onReject();
        onHide();
    };
    return (
        <DBModal
            minWidth={300}
            show={show}
            onHide={onHide}
            className="install-app-modal"
        >
            <DBModal.Content>
                <h2>کاربر گرامی</h2>
                <p>
                    با افزودن فیدیما به موبایل خود، آسان‌تر از آن استفاده کنید.
                </p>
                <div className="button-container">
                    <DBButton
                        type="primary"
                        caption="نصب و افزودن"
                        className="add-button"
                    />
                    <DBButton
                        type="secondary"
                        caption="بعدا یادآوری کن"
                        onClick={onRejectHandle}
                    />
                </div>
            </DBModal.Content>
        </DBModal>
    );
}
